import { useState, useEffect } from 'react'
import { Program } from '../types'
import { fetchOtherEpisodes } from '../utils/program'

export function useProgramOtherEpisodes(callLetter: string, titleId: string) {
  const [data, setData] = useState<Program[] | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)
  useEffect(() => {
    async function load() {
      setIsLoading(true)
      try {
        const channels = await fetchOtherEpisodes(callLetter, titleId)
        setData(channels)
      } catch (err) {
        setError(err as Error)
      } finally {
        setIsLoading(false)
      }
    }
    if (callLetter && titleId) load()
    else {
      setData(null)
      setIsLoading(false)
      setError(null)
    }
  }, [callLetter, titleId])

  return { data, isLoading, error }
}
